import api from "./api";

export function find() {
  return new Promise((resolve, reject) => {
    api
      .get("/user-access-policy")
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function merge(values) {
  return new Promise((resolve, reject) => {
    api
      .put("/user-access-policy", values)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}
